import React from 'react';
import { View, Text, ScrollView, StyleSheet, TouchableOpacity } from 'react-native-web';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <ScrollView style={styles.container} contentContainerStyle={styles.contentContainer}>
      <TouchableOpacity dataSet={{ hover: "lift" }} onPress={() => navigate(-1)} style={styles.backButton}>
        <Text style={styles.backButtonText}>← Back</Text>
      </TouchableOpacity>
      
      <Text style={styles.title}>Privacy Policy</Text>
      
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>1. Information Collection</Text>
        <Text style={styles.text}>
          Bonita Bikes collects your phone number when you provide it during the booking process or when you sign up for our services. We use this information to send you booking confirmations, status updates, and important alerts related to your rental.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>2. Use of Information</Text>
        <Text style={styles.text}>
          Your phone number is strictly used for delivering transactional messages and notifications regarding your service with us. We may also send you occasional marketing offers if you have explicitly opted in to receive them.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>3. Information Sharing</Text>
        <Text style={styles.text}>
          We do not sell, rent, or share your personal information, including your mobile phone number, with third parties or affiliates for marketing or promotional purposes. Your information is only shared with our service providers (such as messaging platforms) as necessary to deliver our services to you.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>4. Opt-Out Rights</Text>
        <Text style={styles.text}>
          You have the right to opt out of receiving text messages from us at any time. To stop receiving messages, simply reply STOP to any message we send. After you send the SMS message "STOP" to us, we will send you an SMS message to confirm that you have been unsubscribed. After this, you will no longer receive SMS messages from us. If you want to join again, just sign up as you did the first time and we will start sending SMS messages to you again.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>5. Help and Support</Text>
        <Text style={styles.text}>
          If you are experiencing issues with the messaging program you can reply with the keyword HELP for more assistance, or you can get help directly at help@bonitabikes.com.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>6. Contact Us</Text>
        <Text style={styles.text}>
          If you have any questions about this Privacy Policy, please contact us at help@bonitabikes.com.
        </Text>
      </View>
      
      <View style={styles.footer}>
        <Text style={styles.footerText}>Last Updated: December 2025</Text>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  contentContainer: {
    padding: 20,
    maxWidth: 800,
    alignSelf: 'center',
    width: '100%',
  },
  backButton: {
    marginBottom: 20,
    padding: 10,
  },
  backButtonText: {
    color: '#0E7C6B',
    fontSize: 16,
    fontWeight: '600',
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    marginBottom: 24,
    color: '#2E3A38',
  },
  section: {
    marginBottom: 24,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '600',
    marginBottom: 8,
    color: '#2E3A38',
  },
  text: {
    fontSize: 16,
    lineHeight: 24,
    color: '#5C6B68',
  },
  footer: {
    marginTop: 40,
    paddingTop: 20,
    borderTopWidth: 1,
    borderTopColor: '#EDF1F0',
  },
  footerText: {
    fontSize: 14,
    color: '#8A9794',
    textAlign: 'center',
  },
});

export default PrivacyPolicy;
